var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_37995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 10.6654V7.9987M7.99976 5.33203H8.00643M14.6664 7.9987C14.6664 11.6806 11.6817 14.6654 7.99976 14.6654C4.31786 14.6654 1.3331 11.6806 1.3331 7.9987C1.3331 4.3168 4.31786 1.33203 7.99976 1.33203C11.6817 1.33203 14.6664 4.3168 14.6664 7.9987Z",
    stroke: "#E93A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_37995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.a1277f662477a2bc16ce39cb39ee13a6.svg";
export { ForwardRef as ReactComponent };